import { createContext, type ReactNode, useContext, useMemo } from 'react';
import { type WrapFn } from './types';

export interface ShadowGlobalProps {
  wrap?: WrapFn;
}

const ShadowGlobalPropsContext = createContext<ShadowGlobalProps | undefined>(
  undefined
);

export interface ShadowGlobalPropsProviderProps {
  wrap?: WrapFn;
  children?: ReactNode;
}

export function ShadowGlobalPropsProvider({
  wrap,
  children
}: ShadowGlobalPropsProviderProps) {
  const globalProps: ShadowGlobalProps = useMemo(() => ({ wrap }), [wrap]);

  return (
    <ShadowGlobalPropsContext.Provider value={globalProps}>
      {children}
    </ShadowGlobalPropsContext.Provider>
  );
}

export function useShadowGlobalProps() {
  return useContext(ShadowGlobalPropsContext);
}
